import { useEffect, useState } from 'react';

import { useOAuth } from '@/hooks';

const useFrozenOAuth = ({ source, target, isFrozen }) => {
  const {
    source: { [source]: sourceAuth },
    target: { [target]: targetAuth },
  } = useOAuth();

  const [frozenAuth, setFrozenAuth] = useState({});

  useEffect(() => {
    if (isFrozen) {
      setFrozenAuth({ sourceAuth, targetAuth });
    }
  }, [isFrozen]);

  return isFrozen ? frozenAuth : { sourceAuth, targetAuth };
};

export default useFrozenOAuth;
